import { render } from "./DateTime.vue?vue&type=template&id=8e662e24&scoped=true"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"

import "./DateTime.vue?vue&type=style&index=0&id=8e662e24&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e662e24"]])

export default __exports__